import React, { useCallback, useEffect, useRef, useState } from 'react';
import AccordionContext from './context/accordion-context';
import noop from '../utils/noop';

const defaultOpenedItems = [];

// @ts-ignore TS(2322): Type 'string' is not assignable to type 'ReactElem... Remove this comment to see the full error message
function Accordion({
  allowMultipleItemsOpened = true,
  component: Component = 'div',
  openedAccordionItems = defaultOpenedItems,
  shouldPreventAnimation = false,
  shouldPreventInitialAnimation = false,
  onMount = noop,
  children,
  ...otherProps
}) {
  const [openedItems, setOpenedItems] = useState([]);
  const componentRef = useRef(null);
  const isRendered = componentRef.current;

  const getOpenedItems = useCallback(
    (items) => (allowMultipleItemsOpened ? items : items.slice(-1)),
    [allowMultipleItemsOpened]
  );

  const isInitialAnimationPrevented = useRef(shouldPreventInitialAnimation);

  useEffect(() => {
    setOpenedItems(getOpenedItems(openedAccordionItems));
  }, [openedAccordionItems, allowMultipleItemsOpened, getOpenedItems]);

  useEffect(() => {
    if (isRendered) {
      onMount();
      if (shouldPreventInitialAnimation) {
        isInitialAnimationPrevented.current = false;
      }
    }
  }, [isRendered, onMount, shouldPreventInitialAnimation]);

  const toggleItemOpen = useCallback(
    (itemId) => {
      // @ts-ignore TS(2345): Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
      const newOpenedItems = openedItems.includes(itemId)
        ? openedItems.filter((openedItem) => openedItem !== itemId)
        : [...openedItems, itemId];
      setOpenedItems(getOpenedItems(newOpenedItems));
    },
    [openedItems, setOpenedItems, getOpenedItems]
  );

  return (
    <AccordionContext.Provider
      // @ts-ignore TS(2322): Type '{ openedItems: never[]; toggleItemOpen: (ite... Remove this comment to see the full error message
      value={{
        openedItems,
        toggleItemOpen,
        shouldPreventAnimation: isInitialAnimationPrevented.current || shouldPreventAnimation,
      }}
    >
      {/* @ts-ignore TS(2604): JSX element type 'Component' does not have any con... Remove this comment to see the full error message */}
      <Component {...otherProps} ref={componentRef}>
        {children}
      </Component>
    </AccordionContext.Provider>
  );
}

export default Accordion;
